import { followWhatsAppChannelMessage, useWhatsAppChannelUrl } from 'hooks/useWhatsAppChannelUrl'
import { getSVGImageUrl } from 'lib/image/imageUtils'
import { memo } from 'react'
import { useIntl } from 'react-intl'
import NavBarButton from '../NavBarButton/NavBarButton'

function NavBarWhatsAppChannelButton() {
  const intl = useIntl()
  const channelUrl = useWhatsAppChannelUrl()
  if (!channelUrl) {
    return null
  }

  return <NavBarButton
    size="small"
    icon={<img src={getSVGImageUrl('whatsapp-logo')} width="20" height="20" alt={intl.formatMessage(followWhatsAppChannelMessage)} />}
    href={channelUrl}
    target="_blank"
    rel="noopener"
  />
}

export default memo(NavBarWhatsAppChannelButton)
